import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import { consultarEstatus } from '../services/api'; // Lo crearemos en el siguiente paso

const ConsultaEstatus = () => {
  const [codigo, setCodigo] = useState('');
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResultado(null);
    if (!codigo) {
      setError('Por favor, introduce un código de seguimiento.');
      return;
    }
    try {
      const response = await consultarEstatus(codigo);
      setResultado(response.data);
    } catch (err) {
      setError('Código no encontrado o error en la consulta.');
      console.error(err);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        Consultar Estatus de Solicitud
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="codigo_seguimiento"
          label="Introduce tu código de seguimiento"
          name="codigo_seguimiento"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
        />
        <Button type="submit" fullWidth variant="contained" color="secondary" sx={{ mt: 2, mb: 2 }}>
          Consultar
        </Button>
      </Box>
      {resultado && (
        <Alert severity="success" sx={{ mt: 2 }}>
          <Typography><strong>Código:</strong> {resultado.codigo_seguimiento}</Typography>
          <Typography><strong>Fecha de Creación:</strong> {new Date(resultado.fecha_creacion).toLocaleString()}</Typography>
          <Typography><strong>Estatus:</strong> {resultado.estatus}</Typography>
        </Alert>
      )}
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Paper>
  );
};

export default ConsultaEstatus;